import { LandingPageUrl } from '@dev/ee-api/ee-api-models';
import { ApplicationState } from '..';

import * as Types from './types';

const { ActionTypes } = Types;

export const AddLandingPageSubdomain = (subdomain: LandingPageUrl): Types.AddLandingPageSubdomainAction => ({
    type: ActionTypes.ADD_LANDING_PAGE_SUBDOMAIN,
    payload: subdomain,
    meta: {
        thunk: true,
    },
});

export const UpdateLandingPageSubdomain = (subdomain: LandingPageUrl): Types.UpdateLandingPageSubdomainAction => ({
    type: ActionTypes.UPDATE_LANDING_PAGE_SUBDOMAIN,
    payload: subdomain,
    meta: {
        thunk: true,
    },
});
export const AddLandingPageAccountSubdomain = (subdomain: string): Types.AddLandingPageAccountSubdomainAction => ({
    type: ActionTypes.ADD_LANDING_PAGE_TO_ACCOUNT_SUBDOMAIN,
    payload: subdomain,
    meta: {
        thunk: true,
    },
});

export const UpdateLandingPageAccountSubdomain = (
    subdomain: string
): Types.UpdateLandingPageAccountSubdomainAction => ({
    type: ActionTypes.UPDATE_LANDING_PAGE_TO_ACCOUNT_SUBDOMAIN,
    payload: subdomain,
    meta: {
        thunk: true,
    },
});

export const LandingPageSubdomainError = (
    meta: Record<string, unknown>,
    errorKey
): Types.LandingPageSubdomainError => ({
    type: ActionTypes.LANDING_PAGE_SUBDOMAIN_ERROR,
    payload: {
        errorKey,
    },
    meta,
    error: true,
});

export const LandingPageSubdomainSuccess = (
    subdomain: Types.LandingPageSubdomainModel,
    meta?: Record<string, any>
): Types.LandingPageSubdomainSuccess => ({
    type: ActionTypes.LANDING_PAGE_SUBDOMAIN_SUCCESS,
    payload: {
        subdomain,
    },
    meta,
});

export const LoadLandingPageSubdomain = (landingPageId?: number): Types.LoadLandingPageSubdomainAction => ({
    type: ActionTypes.GET_LANDING_PAGE_SUBDOMAIN,
    payload: {
        landingPageId,
    },
});

export const LandingPageSkipSubdomainLoading = (): Types.LandingPageSkipSubdomainLoading => ({
    type: ActionTypes.LANDING_PAGE_SKIP_SUBDOMAIN_LOADING,
});

export const getAccountLandingPageSubdomain = (state: ApplicationState) => state.landingPageSubdomain?.accountSubdomain;
export const getLandingPageSubdomain = (state: ApplicationState) => state.landingPageSubdomain;
